import { GetOriginalPdfResponse } from '@dc-shared-web/hooks/api/document/getOriginalPdf'

export type DownloadOriginalPdfHandlers = {
  onSuccess: (response: GetOriginalPdfResponse) => void
  onError: (error: unknown) => void
}

export const createDownloadHandlers = (
  fileName: string,
  toast: (params: {
    variant: 'success' | 'error'
    title: string
    description: string
  }) => void
): DownloadOriginalPdfHandlers => ({
  onSuccess: (response) => {
    if (response.error) {
      console.error('Failed to download PDF:', response.error)
      toast({
        variant: 'error',
        title: 'Download failed',
        description: 'Failed to download the original PDF. Please try again.',
      })
      return
    }
    const url = URL.createObjectURL(response.data)
    const link = window.document.createElement('a')
    link.href = url
    link.download = fileName.toLowerCase().endsWith('.pdf')
      ? fileName
      : `${fileName}.pdf`
    link.click()
    URL.revokeObjectURL(url)
  },
  onError: (error) => {
    console.error('Failed to download PDF:', error)
    toast({
      variant: 'error',
      title: 'Download failed',
      description: 'Failed to download the original PDF. Please try again.',
    })
  },
})
